import { useState } from 'react';
import { DayPicker } from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { Box, ButtonBase, Popover, useMediaQuery, useTheme } from '@mui/material';
import { format } from 'date-fns';

import Calendar from '~/assets/icons/analytics/calendar.svg?react';
import { Text } from '~/components/ui/text';

import { useStyles } from './dateRangePicker.styles';

import 'react-day-picker/dist/style.css';

type RangeProp = {
  from: Date;
  to: Date;
};

type DateRangePickerProps = {
  range: RangeProp;
  setRange: ({ from, to }: RangeProp) => void;
  maxDate?: Date;
};

export function DateRangePicker({ range, setRange, maxDate }: DateRangePickerProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const styles = useStyles();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const formattedRange =
    range.from && range.to
      ? `${format(range.from, 'MMM d, yyyy')} - ${format(range.to, 'MMM d, yyyy')}`
      : 'Please select a date range';

  return (
    <>
      <Box sx={styles.pickerContainer}>
        <Text variant="inputVerySmall">Pick a range:</Text>
        <ButtonBase onClick={handleClick} sx={styles.pickerBtn}>
          {formattedRange}
          <Calendar />
        </ButtonBase>
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={styles.datePickerWrapper}>
          <DayPicker
            // locale={"en"}
            mode="range"
            selected={range}
            onSelect={setRange}
            numberOfMonths={isTablet ? 1 : 2}
            pagedNavigation
            weekStartsOn={0}
            disabled={{ after: maxDate }}
          />
        </Box>
      </Popover>
    </>
  );
}
